import { Card, Col, Row } from "react-bootstrap";
import { HorizontalDivider } from "../../../common/components/core";
import { ApproverDetailsPersonalInfo } from "../../../types/claim";

type ApproverListProps = {
    projectClaimApprovers: ApproverDetailsPersonalInfo[];
    projectPaymentOrderApprovers: ApproverDetailsPersonalInfo[];
};

const ApproverList = ({
    projectClaimApprovers,
    projectPaymentOrderApprovers,
}: ApproverListProps): JSX.Element => {
    const formatNameCompany = (
        approverDetails: ApproverDetailsPersonalInfo,
    ) => {
        return `${approverDetails.lastName} ${approverDetails.firstName} (${
            approverDetails.userProfileName ?? ""
        })`;
    };

    return (
        <Card.Body className="mb-3 border-0 px-0 py-1">
            <Row>
                <Col>
                    <h3>Claim Approvers</h3>
                    <HorizontalDivider />
                </Col>
                <Col>
                    <h3>Payment Order Approvers</h3>
                    <HorizontalDivider />
                </Col>
            </Row>
            <Row>
                <Col>
                    {/* TODO: May duplicate, email can't be key */}
                    {projectClaimApprovers.map((it, index) => (
                        <p className={'mb-2'} key={it.email + index}>{formatNameCompany(it)}</p>
                    ))}
                </Col>
                <Col>
                    {projectPaymentOrderApprovers.map((it, index) => (
                        <p className={'mb-2'} key={it.email + index}>
                            {`${index + 1}. ${formatNameCompany(it)}`}
                        </p>
                    ))}
                </Col>
            </Row>
        </Card.Body>
    );
};

export default ApproverList;
